module.exports = "<p class=\"alert alert-info\">Message d’info</p>\n\n#### Titre de niveau 4\n\n##### Titre de niveau 5\n\n###### Titre de niveau 6";